export default __webpack_public_path__ + "static/media/1.37726cf4.webp";